import styles from './DesignerBuilder.module.css'
import React, { useState, useMemo } from 'react'
import { Slider, Button } from 'antd'
const CANVAS_WIDTH = 1920
const CANVAS_HEIGHT = 1080

function Canvas({ zoom }) {
  const width = useMemo(() => CANVAS_WIDTH * (zoom / 100), [zoom])
  const height = useMemo(() => CANVAS_HEIGHT * (zoom / 100), [zoom])

  return (
    <div
      className={styles.example__canva}
      style={{
        width: `${width}px`,
        height: `${height}px`,
        boxShadow: '0 2px 8px rgba(14,19,24,0.07)',
      }}
    ></div>
  )
}

function DesignerBuilder() {
  const [zoom, setZoom] = useState(100)
  const [isSidebarEditorOpen, setIsSidebarEditorOpen] = useState(false)

  const handleSidebarEditorToggle = () => {
    setIsSidebarEditorOpen(!isSidebarEditorOpen)
  }

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <Button onClick={handleSidebarEditorToggle}>
          {isSidebarEditorOpen
            ? 'Fermer la barre latérale'
            : 'Ouvrir la barre latérale'}
        </Button>
      </div>
      <div className={styles.content}>
        <div className={styles.sidebar}></div>
        {isSidebarEditorOpen && (
          <div className={styles.sidebarEditor}>
            <div className={styles.false__container}></div>
          </div>
        )}
        <div className={styles.main}>
          <div className={styles.innerHeader}></div>
          <div className={styles.body}>
            <div className={styles.containerBody}>
              <div className={styles.contentBody}>
                <div className={styles.bodyContain}>
                  <div className={styles.bodyItem}></div>
                  <div className={styles.bodyCanvas}>
                    <div className={styles.container__canvas}>
                      <Canvas zoom={zoom} />
                      <Canvas zoom={zoom} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={styles.innerFooter}>
            <Slider
              className={styles.slider}
              min={10}
              max={500}
              value={zoom}
              onChange={(value) => setZoom(value)}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
export default DesignerBuilder
